import htmlDecode from './htmlDecode';

const formatFacet = (value, field) => {
  return `${field}:${value}`;
}

const formatCheckboxesFacets = (fieldId, fieldValues) => {
  if (!fieldValues.length || !fieldId) {
    return null;
  }

  return fieldValues.map((value) => {
    return formatFacet(value, fieldId);
  });
};

const collectFacetQuery = (filters) => {
  const facets = [];
  Object.entries(filters).forEach(([key, value]) => {
    let facet = '';
    if (value) {
      if (Array.isArray(value)) {
        facet = formatCheckboxesFacets(key, value);
      }
      else if (typeof value === 'object') {
        facet = [formatFacet(value.value, key)];
      }
      else if (typeof value == 'string') {
        facet = [formatFacet(value, key)];
      }
    }

    if (facet) {
      facets.push(facet)
    }
  });

  return facets;
};

const formatFilters = (fieldValues) => {
  if (!fieldValues.length) {
    return null;
  }
  let result = '';

  fieldValues.forEach((value) => {
    result += value && result ? ` AND ${value}` : value;
  });

  return result;
};

const collectFilterQuery = (filters) => {
  let query = [];
  Object.values(filters).forEach((value) => {
    if (Array.isArray(value)) {
      let selectQuery = '';
      if (value.length && typeof value[0] === 'object') {
        value.forEach((item) => {
          selectQuery += selectQuery ? ` OR ${item.value}` : item.value;
        });
        selectQuery = selectQuery.includes(' OR ') ? `(${selectQuery})` : `${selectQuery}`;
        query = [...query, selectQuery];
      }
      else {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            selectQuery += selectQuery ? ` OR ${item}` : item;
          });
          selectQuery = selectQuery.includes(' OR ') ? `(${selectQuery})` : `${selectQuery}`;
          query = [...query, selectQuery];
        }
        else {
          query = [...query, ...value];
        }
      }
    }
    else {
      query = [...query, value];
    }
  });

  return formatFilters(query);
};

const createSelectOptions = (array, id, labelKey, valueKey, imgKey) => {
  if (!array || !array.length) {
    return [];
  }

  return array.map((item) => {
    return {
      value: `${id}:${item[valueKey]}`,
      label: htmlDecode(item[labelKey]),
      img: item[imgKey],
    }
  });
}

export {formatCheckboxesFacets, formatFacet, formatFilters, collectFacetQuery, collectFilterQuery, createSelectOptions};
